//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ICalendarConflictDisplayItem } from './ICalendarConflictDisplayItem';
import { CalendarEventUpdateNotAllowedReason } from './Enums';

export class CalendarUpdateEventRequirementsDisplayItem extends ItemBase {
    StudentIDsNotAssignedToTeacher: string[] = [];
    CalendarConflicts: ICalendarConflictDisplayItem[] = [];
    HasStudentVariation: boolean = false;
    HasRecordedAttendance: boolean = false;
    IsDestructive: boolean = false;
    NotAllowedReason: CalendarEventUpdateNotAllowedReason | null = null;

    constructor(initializer?: Partial<CalendarUpdateEventRequirementsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarUpdateEventRequirementsDisplayItem";
}
